import React from 'react';
import { Input,Button,Form } from 'antd';
import NHSelect from "../../common/NHSelect";
import NHFormItem from "../../common/NHFormItem";
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import {readOption} from "../readCard";
import NHFetch from "../../../utils/NHFetch";
import PropTypes from 'prop-types';

const FormItem  = Form.Item;
const basicUrl = '/yxxc/';
class AutoHandleSearchPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false, //是否正在查询
            mrzhlx: 'sfzjh', //默认帐号类型
            dataSource: [], //备选数据源
            tooltipVisiable: false, //切换查询框类型提示
            dkqValue:"",//读卡器
        }
    }

    componentDidMount(){
        //默认搜索输入框获取焦点
        const searchInput = this.searchInput;
        searchInput.focus();

        this.getDkqData();
    }


    // 获取读卡器代码库数据
    getDkqData = () => {
        let userIds = getLoginUser() ? getLoginUser().userId : '';
        NHFetch("/proData/selectDataList","get",'sign=DMK_XTGL_SFZDKQ').then(res => {
            this.setState({
                dkqList:res.data
            },()=>{
                this.getReadSfzdkqpz(userIds);
            })
        })
    }

    // 获取读卡器配置 
    getReadSfzdkqpz = (userIds) => {
        //这里的地址是模拟的
        const {dkqList} = this.state;
        let dkqType = "";
        let uuid = "";
        let dkqdata = '';
        let list = JSON.parse(localStorage.getItem("DkqList"))?JSON.parse(localStorage.getItem("DkqList")):[];
        console.log(list);
        if(list.length > 0){
            list.map((item,index) => {
                console.log("item----",item,index);
                if(item.userId == userIds){
                    console.log(item,index);
                    dkqdata = item.Value;
                }
            })
        }
        console.log("dkqdata",dkqdata);
        let csbz = 'XTGL_SFZDKQ';
        NHFetch(basicUrl + 'getReadCsxx', 'GET', {csbz:csbz})
            .then(res => {
                if (res) {
                    let dkqValue = "";
                    if(dkqdata == '' || dkqdata == undefined || dkqdata == null){
                        console.log("没有存储值");
                        dkqdata = res.data;
                    }
                    console.log("dkqdata--------",dkqdata);
                    dkqList.map(item => {
                        if(dkqdata != null){
                            if(item.VALUE == dkqdata){
                                dkqValue = item.LABEL;
                            }
                        }
                    })
                        this.setState({ type: dkqdata!=null?dkqdata:'xzx',dkqValue:dkqValue});
                }
            });
    }

    //自动读卡
    autoReadIdCard = () => {
        let { type, readPort} = this.state;
        console.log(type);
        if(type != "DS_K56A0_D") {
            readOption(type,readPort,'auto',(data) => {
                const { setFieldsValue } = this.props.form;
                setFieldsValue({ zhlx: 'sfzjh', zh: data });
                this.autoHandleSearch();
            });
        }else{
            readOption(type,readPort,'auto',(data) => {
                console.log("返回数据---",data);
                const { setFieldsValue } = this.props.form;
                setFieldsValue({ zhlx: 'sfzjh', zh: data.id });
                this.autoHandleSearch();
            });
        }
    }

    //手动读卡
    manualReadIdCard = () => {
        let { type, readPort} = this.state;
        if(type != "DS_K56A0_D") {
            readOption(type,readPort,'manual',(data) => {
                const { setFieldsValue } = this.props.form;
                setFieldsValue({ zhlx: 'sfzjh', zh: data });
                this.autoHandleSearch();
            });
        }else{
            readOption(type,readPort,'manual',(data) => {
                const { setFieldsValue } = this.props.form;
                setFieldsValue({ zhlx: 'sfzjh', zh: data.id });
                this.autoHandleSearch();
            });
        }
    }

    autoHandleSearch =() =>{
        const form = this.props.form;
        const autoHandleSearch = this.props.autoHandleSearch;
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if (autoHandleSearch && formData.zh) {
                this.setState({ loading: true });
                autoHandleSearch(formData, () => { this.setState({ loading: false }) });
            }
        });
    }

    //点击查询按钮回调
    handleSearchBtnClick = () => {
        this.autoHandleSearch();
    }

    //读卡器回调
    dkqandleSelectChange = (e) =>{
        let userIds = getLoginUser().userId?getLoginUser().userId:"";
        console.log("读卡器类型",e);
        let flag = false;
        let DkqList = '';
        let list = JSON.parse(localStorage.getItem("DkqList"))?JSON.parse(localStorage.getItem("DkqList")):[];
        if(list.length > 0){
            list.map(item=>{
                if(item.userId == userIds){
                    item.Value = e;
                    flag = true;
                }else{
                    console.log("添加~");
                }
            })
            if(!flag){
                list.push({'userId':userIds,'Value':e});//要存储的json对象
                console.log("list------",list);
            }
        }else{
        list.push({'userId':userIds,'Value':e});//要存储的json对象
        console.log("list------",list);
        }
        DkqList = JSON.stringify(list);//将json对象转化成字符串
        localStorage.setItem('DkqList',DkqList);
        
        const { dkqList } = this.state;
        let dkqValue = "";
        dkqList.map(item => {
            if(e != null){
                if(item.VALUE == e){
                    dkqValue = item.LABEL;
                }
            }else{
                dkqValue = 'xzx'
            }
        })
        this.setState({
            dkqValue,
            type:e
        })
    }

    render() {
        const form = this.props.form;
        const { mrzhlx,loading,type } = this.state;
        return (
            <div>
                <Form layout="inline">
                    <NHFormItem id={'zhlx'} form={form} label={'帐号类型'} formItemLayout={null} required={true}
                                initialValue={mrzhlx == '' ? 'sfzjh' : mrzhlx}>
                        <NHSelect sign={'DMK_YXXT_ZHLX'} style={{ width: 120, border: 0 }} showSearch={false}
                                  filterData={{ type: 'remove', filterkeys: ['']}} disabled={true}  />
                    </NHFormItem>
                    <NHFormItem id={'zh'} form={form} label={'帐号'} formItemLayout={null} required={true}>
                        <Input
                            ref={input => this.searchInput = input}
                            style={{ width: 220 }}
                            placeholder="请输入帐号"
                            autoFocus={true}
                            />
                    </NHFormItem>
                    <FormItem>
                    {hasAuth('zhxg_yxgl_yxxc:autoRead') ? 
                        <NHFormItem id={'dkqlx'} form={form} label={''} formItemLayout={null} required={true}
                            initialValue={type}>
                            <NHSelect sign={'DMK_XTGL_SFZDKQ'} style={{ width: 180, border: 0 }} showSearch={false}
                                filterData={{ type: 'remove', filterkeys: [''] }} onChange={this.dkqandleSelectChange} />
                        </NHFormItem> :null}
                        {/*<Button type="primary" onClick={this.handleSearchBtnClick}> 查询 </Button>*/}
                        {hasAuth('zhxg_yxgl_yxxc:autoRead') ? <Button type="primary" style={{ marginRight: '8px' }} ghost onClick={this.autoReadIdCard}>自动读卡</Button>:null}
                        {hasAuth('zhxg_yxgl_yxxc:manualRead') ? <Button type="primary" style={{ marginRight: '8px' }} ghost onClick={this.manualReadIdCard}>手动读卡</Button>:null}
                    </FormItem>
                </Form>
            </div>
        );
    }
}
const AutoHandleSearch = Form.create()(AutoHandleSearchPage);
export default AutoHandleSearch;

AutoHandleSearchPage.propTypes={
    autoHandleSearch:PropTypes.func, //查询方法回调
}



// WEBPACK FOOTER //
// ./components/yxxc/autoHandle/autoHandleSearch.js